import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { CTA } from "../../../../../components/CTA";
import { BetaMasthead } from "../../../components/BetaMasthead";
import { z } from "zod";
import { BetaRegistrationMastheadBladeSchema, } from "../../../schemas/BetaRegistrationMasthead";
import { useBetaRegisterHandler } from "../../../functional/hooks/useBetaRegisterHandler";
import { BetaLoader } from "../../../components/BetaLoader";
import { Media } from "../../../../../components/Media";
import { AspectRatio } from "../../../../../components/AspectRatio";
import { getMediaAspectRatio } from "../../../../../functional/getMediaAspectRatio";
export const BetaRegistrationMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal("betaRegistrationMasthead"),
});
const _BetaRegistrationMasthead = ({ header, className, backdrop, campaignID, platformIcons, buttons = [], rating, ...bladeProps }) => {
    const { isLoading: isHandlerLoading, handleButtonClick } = useBetaRegisterHandler({ campaignID });
    const { ratingImage, ratingText } = rating || {};
    const isCtaDisabled = isHandlerLoading;
    const title = buttons[0]?.title;
    return (React.createElement(BetaLoader, { isLoading: isHandlerLoading, isAllowedRoute: true, palette: "palette3" },
        React.createElement(BetaMasthead, { header: header, backdrop: backdrop, platformIcons: platformIcons, className: className, ...bladeProps },
            React.createElement("div", { className: "content" },
                title && (React.createElement(CTA, { onClick: isCtaDisabled ? undefined : handleButtonClick, className: "primary-cta", disabled: isCtaDisabled }, title)),
                (ratingImage || ratingText) && (React.createElement("div", { className: "ratings" },
                    React.createElement("div", { className: "ratings-content" },
                        ratingImage && (React.createElement("div", { className: "rating-logo" },
                            React.createElement(AspectRatio, { ratio: getMediaAspectRatio(ratingImage, 1) },
                                React.createElement(Media, { media: ratingImage })))),
                        ratingText && (React.createElement("div", { className: "rating-text-container" }, ratingText.split(/\n|\\n/).map((textItem, idx) => {
                            return (React.createElement("p", { className: "rating-text-item", key: idx }, textItem));
                        }))))))))));
};
export const BetaRegistrationMasthead = styled(_BetaRegistrationMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=BetaRegistrationMasthead.js.map